<template>
<td>
  <div v-if="type === 'img'">
    <img width="50px" :src="formattedValue" />
  </div>
  <div v-else-if="type === 'icon'">
    <i :class="formattedValue"></i>
  </div>
  <div v-else-if="type === 'custom-html'">
    <div v-html="formattedValue"></div>
  </div>
  <div v-else-if="type === 'boolean-circle'" style="text-align:center">
    <span v-if="formattedValue" class="circleTrue"></span>
    <span v-if="!formattedValue" class="circleFalse"></span>
  </div>
  <div v-else-if="type === 'a'">
    <a target="_blank" :href="formattedValue">
      <i style="font-size: 20px; transform: translateY(4px);" class="material-icons">link</i>
    </a>
  </div>
  <div v-else-if="type === 'internal-link'">
    <router-link :to="{ path: options.path}" >
      {{ formattedValue }}
    </router-link>
  </div>
  <div v-else-if="type === 'date'">
    <span class="date">
      {{ formattedValue }}
    </span>
  </div>
  <div v-else>
    <span>{{ formattedValue }}</span>
  </div>
</td>
</template>

<script>
import moment from 'moment'
const valueTypes = ['text', 'img', 'date', 'icon', 'external-link', 'internal-link', 'boolean-circle', 'enum', 'custom']

export default {
  name: 'tableCell',
  components: {},
  mounted: function() {},
  props: {
    value: {
      required: true
    },
    type: {
      type: String,
      default: 'text',
      validator: function(type) {
        return valueTypes.indexOf(type) > -1
      }
    },
    options: {
      type: Object
    }
  },
  data() {
    return {}
  },
  computed: {
    // a computed getter
    formattedValue: function() {
      // `this` points to the vm instance
      switch (this.type) {
        case 'img':
          if (this.options && this.options.staticImg === true) {
            return '/static/img/' + this.value
          } else {
            return this.options.prefix ? this.options.prefix + this.value : this.value
          }
        case 'date':
          return moment(this.value).format(this.options && this.options.format ? this.options.format : 'DD/MM/YYYY')
        case 'boolean-circle':
          return this.value
        case 'enum':
          return this.$t('datatables.' + this.value)
        default:
          return this.value ? this.value : '-'
      }
    }
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../../../scss/config.scss';

.circleTrue,
.circleFalse {
  margin: auto;
}

td > div > img {
  width: 50px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/dataTable/TableCell.vue